import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Customer } from '~move-device/models/customer';
import { MoveDevice } from '~move-device/models/move-device';

export const MoveDeviceActions = createActionGroup({
  source: 'MoveDevice',
  events: {
    'Load Customers': emptyProps(),
    'Load Customers Success': props<{ customers: Customer[] }>(),
    'Load Customers Failure': props<{ error: string }>(),
    'Move Device': props<MoveDevice>(),
    'Move Device Success': emptyProps(),
    'Move Device Failure': props<{ error: string }>(),
  }
});
